<template>
  <section class="section-referral content-padding">
    <div class="row">
      <div class="col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3">
        <div class="card" v-if="referralCodeOwner">
          <div class="card-image">
            <img src="/static/img/bg-invite.jpg" alt="">
          </div>
          <div class="card-body text-center">
            <img v-lazy="referralCodeOwner.picture" class="rounded-circle user-img-ref" width="120">
            <h3>{{ referralCodeOwner.full_name | firstName }} {{ $t('message.promotion.give_you_referral_code') }}</h3>
            <hr>
            <span class="ref-code">{{ $route.query.c }}</span>&nbsp;&nbsp;
            <button class="button button-large -yellow"
                    @click="copyReferralCode"
                    v-clipboard:copy="refCode">
              {{ $t(isCopiedReferralCode) }}
            </button>
            <hr>
            <router-link to="/booking/start" tag="a" class="text-primary">
              <h3>{{ $t("message.hero.action_button") }}</h3>
            </router-link>
          </div>
        </div>
        <div v-else class="text-center">
          {{ $t('message.no_data') }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        refCode: null
      }
    },
    computed: {
      ...mapGetters({
        referralCodeOwner: 'referralCode/getReferralCodeOwner'
      }),
      isCopiedReferralCode () {
        return (this.refCode) ? 'message.button.copied' : 'message.button.copy'
      }
    },
    methods: {
      copyReferralCode () {
        this.refCode = this.$route.query.c
      }
    },
    mounted () {
      this.$store.dispatch('referralCode/LOAD_REFERRAL_CODE_OWNER', this.$route.query.c)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/referral/Index.vue